import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Button from "../Button";
import { post } from "../../lib/Fetching";
import styled, { css } from "styled-components";
import { removeProducts } from "../../lib/ProductActions";

export default class ProductsActionBar extends React.Component {
  state = {
    showReplaceForm: false
  };

  toggleReplaceForm = () =>
    this.setState(state => ({ showReplaceForm: !state.showReplaceForm }));

  completeAction = json => {
    if (json.errors) {
      alert(json.errors);
      return;
    }
    this.setState({ showReplaceForm: false });
    this.props.reloadProducts();
  };

  removeProducts = () => {
    const { productIds } = this.props;
    removeProducts(productIds, this.completeAction);
  };

  render() {
    const { productIds } = this.props;
    const { showReplaceForm } = this.state;
    return (
      <div>
        <div
          className="btn-toolbar"
          style={{ paddingTop: 10, paddingBottom: 10, marginBottom: 10 }}
        >
          <div className="btn-group pull-left">
            <Button
              onClick={this.removeProducts}
              tiny
              deleting
              title="Remove Products"
              disabled={productIds.length == 0}
            />
          </div>
        </div>
      </div>
    );
  }
}

ProductsActionBar.propTypes = {
  productIds: PropTypes.array,
  reloadProducts: PropTypes.func,
  company_id: PropTypes.number
};
